import CompanyPage from '@/components/CompanyPage';
import HomePage from '@/components/HomePage';
import HouseholdPage from '@/components/HouseholdPage';
import MapPage from '@/components/MapPage';
import MyListingsPage from '@/components/MyListingsPage';
import OnboardingGate from '@/components/OnboardingGate';
import WalletPage from '@/components/WalletPage';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/hooks/use-theme';
// import { OAuthProvider } from '@/contexts/OAuthContext';
import { AnimatePresence, motion } from 'framer-motion';
import { JSX, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

function AnimatedRoutes(): JSX.Element {
  const location = useLocation();
  return (
    <AnimatePresence mode='wait'>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.35, ease: 'easeOut' }}
      >
        <Routes location={location}>
          <Route path='/' element={<HomePage />} />
          <Route path='/household' element={<HouseholdPage />} />
          <Route path='/my-listings' element={<MyListingsPage />} />
          <Route path='/company' element={<CompanyPage />} />
          <Route path='/map' element={<MapPage />} />
          <Route path='/wallet' element={<WalletPage />} />
          {/* My Activity + Profile were merged into the Household Wallet page (impact + balance + earnings + profile) */}
          <Route path='/activity' element={<Navigate to='/wallet' replace />} />
          <Route path='/profile' element={<Navigate to='/wallet' replace />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App(): JSX.Element {
  // Register PWA service worker for installability + offline app shell.
  // (main.tsx is template infra and can't be edited, so this runs from here.)
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {
          // Non-fatal — app still works fully online without the SW.
        });
      });
    }
  }, []);

  return (
    <ThemeProvider>
      {/* NOTE: UI Generator - Uncomment OAuthProvider wrapper below if OAuth functionality is needed.
          See .claude/skills/oauth/docs/implementation-guide.md for OAuth implementation guide. */}
      {/* <OAuthProvider> */}
      <div
        id='app-container'
        className='relative min-h-screen flex flex-col bg-background'
      >
        <main id='app-main' className='flex-1'>
          <AnimatedRoutes />
        </main>

        <OnboardingGate />
        <Toaster />
      </div>
      {/* </OAuthProvider> */}
    </ThemeProvider>
  );
}

export default App;
